// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Kr8BO{box-sizing:border-box;width:100%}.XW4bS{flex-shrink:0}.Juc8b{flex:1;overflow:hidden}.Vvd08{display:flex;align-items:baseline;gap:4px;padding:4px 0}.Vvd08.n45lo{justify-content:space-between}.Vvd08.ILhtj{flex-direction:column;align-items:stretch}.NIY6s.xBIkU{min-width:0}.rMwMq{flex:1;min-width:0}.n45lo .rMwMq{flex:unset;min-width:auto}.rMwMq.wXEGh{flex:0 1 auto;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `Kr8BO`,
	"actions": `XW4bS`,
	"rowBeforeActions": `Juc8b`,
	"row": `Vvd08`,
	"spread": `n45lo`,
	"stacked": `ILhtj`,
	"label": `NIY6s`,
	"shrinkable": `xBIkU`,
	"value": `rMwMq`,
	"withInline": `wXEGh`
};
export default ___CSS_LOADER_EXPORT___;
